module.exports = new __parcel__URL__("JuLis.b3b244da.png").toString();